import { createFileRoute } from '@tanstack/react-router'

import { WorkspacesPage } from '@/pages/(auth)/WorkspacesPage'

export const Route = createFileRoute('/workspaces')({
  component: WorkspacesPage,
})
